module.exports = __webpack_public_path__ + "static/media/fuji-screenshot-2.349af732.png";